import { render, staticRenderFns } from "./CourFee.vue?vue&type=template&id=160e7180&"
import script from "./CourFee.vue?vue&type=script&lang=js&"
export * from "./CourFee.vue?vue&type=script&lang=js&"
import style0 from "./CourFee.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports